import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { reportError } from "@/lib/sentry-init";

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
    {
      onUncaughtError: (error, info) => reportError(error, info),
      onCaughtError: (error, info) => reportError(error, info),
    },
  );
});
